import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useNavigate } from 'react-router-dom';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className='container mx-auto px-4 py-8'>
      <div className='max-w-md mx-auto'>
        <Card>
          <CardHeader className='text-center'>
            <CardTitle className='text-6xl font-bold text-muted-foreground'>
              404
            </CardTitle>
            <p className='text-muted-foreground'>Page not found</p>
          </CardHeader>
          <CardContent className='text-center'>
            <Button onClick={() => navigate('/')}>Go Home</Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
